/**
 * V4P Order Manager
 * Links the Product Calculator (middle) with Order Summary (right)
 */
   // Cache bust 2024-01-16-v3
(function() {
  'use strict';

  if (window.V4PNonVetOrderManager) {
  console.warn('V4P Non-Vet Order Manager: already initialized, skipping.');
  return;
}

  // ============================================
  // ORDER STATE
  // ============================================
  let orderLines = [];
  let lineIdCounter = 0;

  // ============================================
  // INIT
  // ============================================
  function init() {
    console.log('V4P Order Manager: Initializing...');
    
    const addBtn = document.getElementById('nv-btn-add-line');
    if (addBtn) {
      addBtn.addEventListener('click', handleAddLine);
      console.log('V4P Order Manager: Add button found and bound');
    } else {
      console.warn('V4P Order Manager: btn-add-line not found!');
    }
    
    // Submit order button
    // NOTE: Submit handling moved to v4p-order-submission.js
    // Order Manager just provides getOrderLines() for data collection
    const submitBtn = document.getElementById('nv-btn-submit-order');
    if (submitBtn) {
      // submitBtn.addEventListener('click', handleSubmitOrder);
      console.log('V4P Order Manager: Submit button found (handled by order-submission.js)');
    }
    
    // Check if calculator is available
    if (window.V4PNonVetCalculator) {
      console.log('V4P Order Manager: Calculator found');
    } else {
      console.warn('V4P Order Manager: Calculator not found yet - may load later');
    }
    
    console.log('V4P Order Manager: Ready');
  }

  // ============================================
  // ADD LINE TO ORDER
  // ============================================
  function handleAddLine() {
    // Get calculator data
    const calc = window.V4PNonVetCalculator;
    if (!calc) {
      console.error('V4PNonVetCalculator not found');
      showError('Calculator not initialized');
      return;
    }
    
    const product = calc.getSelectedProduct();
    const pricing = calc.getSelectedPricing();
    const orderType = calc.getOrderType();
    const fulfilmentMode = calc.getFulfilmentMode();
    const route = calc.getResolvedRoute();
    const repeatData =
      (typeof calc.getRepeatData === 'function' ? calc.getRepeatData() : null) ||
      (typeof window.V4PGetRepeatData === 'function' ? window.V4PGetRepeatData() : null) ||
      null;
    
    // Debug logging
    console.log('=== ADD LINE DEBUG ===');
    console.log('Product:', product);
    console.log('Pricing:', pricing);
    console.log('Order Type:', orderType);
    console.log('Fulfilment:', fulfilmentMode);
    console.log('Route:', route);
    console.log('Repeat Data:', repeatData);
    
    if (!product) {
      showError('Please select a product first');
      return;
    }
    
    // Check for Controlled Drug mixing restriction BEFORE doing anything else
    const isControlledDrug = product.controlledDrug || false;
    console.log('=== CD CHECK ===');
    console.log('Product is CD:', isControlledDrug);
    console.log('Current order lines:', orderLines.length);
    
    if (orderLines.length > 0) {
      const existingHasCD = orderLines.some(l => l.controlledDrug);
      const existingHasNonCD = orderLines.some(l => !l.controlledDrug);
      console.log('Existing has CD:', existingHasCD);
      console.log('Existing has Non-CD:', existingHasNonCD);
      
      if (isControlledDrug && existingHasNonCD) {
        console.log('BLOCKED: Trying to add CD to non-CD basket');
        showError('Controlled Drug products cannot be mixed with non-Controlled Drug products in the same order. Please submit separate orders.');
        // Don't add, don't reset, don't touch anything - just exit
        console.log('Returning early - basket should remain unchanged');
        return;
      }
      if (!isControlledDrug && existingHasCD) {
        console.log('BLOCKED: Trying to add non-CD to CD basket');
        showError('Non-Controlled Drug products cannot be added to an order containing Controlled Drugs. Please submit separate orders.');
        // Don't add, don't reset, don't touch anything - just exit
        console.log('Returning early - basket should remain unchanged');
        return;
      }
    }
    
    console.log('CD check passed - proceeding to add line');

    // Check for Fulfilment Mode mixing restriction
    console.log('=== FULFILMENT MODE CHECK ===');
    console.log('Current fulfilment mode:', fulfilmentMode);
    
    if (orderLines.length > 0) {
      const existingHasCollection = orderLines.some(l => l.fulfilmentMode === 'collection');
      const existingHasDelivery = orderLines.some(l => l.fulfilmentMode === 'delivery');
      console.log('Existing has Collection:', existingHasCollection);
      console.log('Existing has Delivery:', existingHasDelivery);
      
      if (fulfilmentMode === 'collection' && existingHasDelivery) {
        console.log('BLOCKED: Trying to add Collection item to Delivery basket');
        showError('Collection items cannot be mixed with Delivery items in the same order. Please submit separate orders.');
        console.log('Returning early - basket should remain unchanged');
        return;
      }
      if (fulfilmentMode === 'delivery' && existingHasCollection) {
        console.log('BLOCKED: Trying to add Delivery item to Collection basket');
        showError('Delivery items cannot be mixed with Collection items in the same order. Please submit separate orders.');
        console.log('Returning early - basket should remain unchanged');
        return;
      }
    }
    
    console.log('Fulfilment mode check passed - proceeding to build line');
    
    // Build line based on order type
    const repeatDataSafe = repeatData || { repeatType: 'single' };
    let line = {
      id: ++lineIdCounter,
      productName: product.product || 'Unknown Product',
      productId: product.productId,
      variantId: product.variantId || null,
      taxable: product.taxable ?? true,
      uom: product.uom || '',
      orderType: orderType,
      fulfilmentMode: fulfilmentMode,
      route: route || 'VTP',
      repeatType: repeatDataSafe.repeatType || 'single',
      repeatData: repeatDataSafe,
      
      // Flattened repeat fields for easy access
      // Dispense tracking
      totalRepeatsAllowed: repeatDataSafe?.dispenses?.totalDispenses || null,
      currentDispenseStart: repeatDataSafe?.dispenses?.currentDispenseStart || null,
      currentDispenseEnd: repeatDataSafe?.dispenses?.currentDispenseEnd || null,
      usedTodayDispenses: repeatDataSafe?.dispenses?.usedTodayDispenses || null,
      previouslyTaken: repeatDataSafe?.dispenses?.previouslyTaken || 0,
      dispensesRemainingAfterToday: repeatDataSafe?.dispenses?.remainingAfterToday || null,
      
      // Unit tracking
      unitsPerDispense: repeatDataSafe?.units?.unitsPerDispense || null,
      totalUnitsAllocated: repeatDataSafe?.units?.totalAllocated || null,
      unitsPreviouslySupplied: repeatDataSafe?.units?.previouslySupplied || 0,
      unitsTodaysDispense: repeatDataSafe?.units?.todaysDispense || null,
      unitsRemainingAfterToday: repeatDataSafe?.units?.remainingAfterToday || null,
      
      // Scheduling
      intervalDays: repeatDataSafe?.scheduling?.intervalDays || null,
      nextDueDate: repeatDataSafe?.scheduling?.nextDueDate || null,
      isFinalDispense: repeatDataSafe?.scheduling?.isFinalDispense || false,
      
      // Product flags for badges
      // Product flags for badges
      pom: product.pom || false,
      controlledDrug: product.controlledDrug || false,
      coldChain: product.coldChain || false,
      description: product.description || '',  // ✅ ADD THIS LINE
      inStock: product.inStock !== false, // default to true if not specified
      vatRate: (pricing?.vatPercent ?? 20) / 100,  // ✅ Convert % to decimal (20% → 0.20)
      addedAt: new Date().toISOString(),
      prices: {
        customerPack: null,
        pharmacyPack: null,
        customerUnit: null,
        pharmacyUnit: null
      }
    };
    
    if (orderType === 'packs') {
      // PACKS MODE
      const packsInput = document.getElementById('nv-calc-packs-input');
      const rawValue = packsInput?.value;
      const packs = parseInt(rawValue || '0', 10);
      
      console.log('Packs input element:', packsInput);
      console.log('Packs raw value:', rawValue);
      console.log('Packs parsed:', packs);
      
      if (!packs || packs <= 0) {
        showError('Please enter number of packs');
        return;
      }
      
      const packSize = parseInt(product.v4uSize || product.size || 1, 10);
      
      // Check if delivery route (VTCP) - pharmacy cost = customer cost (pass-through)
      const routeLower = (route || '').toLowerCase();
      const isDeliveryRoute = (routeLower === 'vtcp' || routeLower === 'vtcu');
      
      // Canonical 2dp prices (store per-pack prices, then multiply)
      const customerPackPrice = round2(pricing?.packSellPriceIncVat || 0);
      const pharmacyPackPrice = isDeliveryRoute ? customerPackPrice : round2(pricing?.packPurchasePriceIncVat || 0);

      // Line totals derived from canonical per-pack prices
      const customerTotal = round2(packs * customerPackPrice);
      const pharmacyTotal = round2(packs * pharmacyPackPrice);

      console.log('Canonical customer pack price:', customerPackPrice);
      console.log('Canonical pharmacy pack price:', pharmacyPackPrice);
      console.log('Computed customer total:', customerTotal);
      console.log('Computed pharmacy total:', pharmacyTotal);
      console.log('Is delivery route (pass-through):', isDeliveryRoute);
      
      line.packs = packs;
      line.size = packSize;
      line.totalUnits = packs * packSize;
      line.waste = 0;
      line.unitsRequested = null; // keep shape consistent with units-mode lines
      line.prices.customerPack = customerPackPrice;
      line.prices.pharmacyPack = pharmacyPackPrice;
      line.prices.customerUnit = round2(pricing?.unitSellPriceIncVat || 0);
      line.prices.pharmacyUnit = isDeliveryRoute ? line.prices.customerUnit : round2(pricing?.unitPurchasePriceIncVat || 0);

      
      // Single pack selection
      line.packSelection = [{
        productId: product.productId,
        variantId: product.variantId || null,
        productName: product.product || 'Unknown',
        uom: product.uom || '',
        size: packSize,
        quantity: packs,
        packPrice: pharmacyPackPrice,              // per-pack price pharmacy pays (2dp canonical)
        customerPackPrice: customerPackPrice,      // per-pack price customer pays (2dp canonical)
        pharmacyUnitPrice: round2(pricing?.unitPurchasePriceIncVat || 0),
        customerUnitPrice: round2(pricing?.unitSellPriceIncVat || 0)
      }];
      
      // Use displayed totals - for delivery routes, pharmacy = customer
      line.customerTotal = customerTotal;
      line.pharmacyTotal = pharmacyTotal;
      
      console.log('Packs line built:', line);
      
    } else {
      // UNITS MODE - Each pack size becomes a SEPARATE line
      const unitsInput = document.getElementById('nv-calc-units-input');
      const rawValue = unitsInput?.value;
      const units = parseInt(rawValue || '0', 10);
      
      console.log('Units input element:', unitsInput);
      console.log('Units raw value:', rawValue);
      console.log('Units parsed:', units);
      
      if (!units || units <= 0) {
        showError('Please enter units required');
        return;
      }
      
      const algorithmResult = calc.getAlgorithmResult();
      const packSizes = calc.getPackSizes();
      
      console.log('Algorithm Result:', algorithmResult);
      console.log('Pack Sizes:', packSizes);
      
      if (!algorithmResult || !algorithmResult.allocation || algorithmResult.allocation.length === 0) {
        showError('No pack selection calculated');
        return;
      }
      
      // Check if delivery route (VTCP or VTCU)
      // For delivery routes, pharmacy cost = customer cost (pass-through, no margin)
      const routeLower = (route || '').toLowerCase();
      const isDeliveryRoute = (routeLower === 'vtcp' || routeLower === 'vtcu');
      
      console.log('=== UNITS MODE PRICING ===');
      console.log('Route:', route, 'Lower:', routeLower);
      console.log('Is delivery route (pass-through):', isDeliveryRoute);
      
      // Use the allocation array which has pre-calculated values
      algorithmResult.allocation.forEach((alloc, idx) => {
        // Find matching pack info for additional data
        const packInfo = packSizes.find(ps => ps.uom === alloc.uom);
        
        // Calculate customer total from algorithm
        // Canonical per-pack prices (2dp) then multiply
        const customerPackPrice = round2(packInfo?.pricing?.packSellPriceIncVat || 0);
        const pharmacyPackPrice = isDeliveryRoute ? customerPackPrice : round2(alloc.packPurchasePrice || 0);

        const customerTotal = round2((alloc.quantity || 0) * customerPackPrice);

        
        // For delivery routes: pharmacy pays the same as customer (pass-through)
        // For other routes: pharmacy pays for packs at their cost
        const pharmacyTotal = round2((alloc.quantity || 0) * pharmacyPackPrice);
        
        console.log('Alloc', idx, ':', {
          uom: alloc.uom,
          quantity: alloc.quantity,
          customerRevenue: alloc.customerRevenue,
          packPurchasePrice: alloc.packPurchasePrice,
          customerTotal,
          pharmacyTotal,
          isDeliveryRoute
        });
        
        const packLine = {
          id: ++lineIdCounter,
          productName: product.product || 'Unknown Product',
          productId: packInfo?.productId || product.productId || null,
          variantId: packInfo?.variantId || product.variantId || null,
          taxable: packInfo?.taxable ?? product.taxable ?? true,
          uom: alloc.uom || '',
          size: alloc.size || 1,
          orderType: 'units',
          fulfilmentMode: fulfilmentMode,
          route: route || 'VTP',
          repeatType: repeatDataSafe.repeatType || 'single',
          repeatData: repeatDataSafe,
          
          // Flattened repeat fields for easy access
          // Dispense tracking
          totalRepeatsAllowed: repeatDataSafe?.dispenses?.totalDispenses || null,
          currentDispenseStart: repeatDataSafe?.dispenses?.currentDispenseStart || null,
          currentDispenseEnd: repeatDataSafe?.dispenses?.currentDispenseEnd || null,
          usedTodayDispenses: repeatDataSafe?.dispenses?.usedTodayDispenses || null,
          previouslyTaken: repeatDataSafe?.dispenses?.previouslyTaken || 0,
          dispensesRemainingAfterToday: repeatDataSafe?.dispenses?.remainingAfterToday || null,
          
          // Unit tracking
          unitsPerDispense: repeatDataSafe?.units?.unitsPerDispense || null,
          totalUnitsAllocated: repeatDataSafe?.units?.totalAllocated || null,
          unitsPreviouslySupplied: repeatDataSafe?.units?.previouslySupplied || 0,
          unitsTodaysDispense: repeatDataSafe?.units?.todaysDispense || null,
          unitsRemainingAfterToday: repeatDataSafe?.units?.remainingAfterToday || null,
          
          // Scheduling
          intervalDays: repeatDataSafe?.scheduling?.intervalDays || null,
          nextDueDate: repeatDataSafe?.scheduling?.nextDueDate || null,
          isFinalDispense: repeatDataSafe?.scheduling?.isFinalDispense || false,
          
          // Product flags for badges
          // Product flags for badges
          pom: product.pom || false,
          controlledDrug: product.controlledDrug || false,
          coldChain: product.coldChain || false,
          description: product.description || '',  // ✅ ADD THIS LINE
          inStock: packInfo?.inStock !== false,
          vatRate: (packInfo?.pricing?.vatPercent ?? 20) / 100,  // ✅ Convert % to decimal
          addedAt: new Date().toISOString(),

          prices: {
            customerPack: customerPackPrice,
            pharmacyPack: pharmacyPackPrice,
            customerUnit: round2(packInfo?.pricing?.unitSellPriceIncVat || 0),
            pharmacyUnit: isDeliveryRoute ? round2(packInfo?.pricing?.unitSellPriceIncVat || 0) : round2(packInfo?.pricing?.unitPurchasePriceIncVat || 0)
          },
          
          // Pack details
          packs: alloc.quantity,
          unitsRequested: alloc.unitsToCustomer,
          totalUnits: alloc.unitsAvailable,
          waste: alloc.unitsLeftover || 0,
          
          // Single pack in selection
          packSelection: [{
            productId: packInfo?.productId || product.productId || null,
            variantId: packInfo?.variantId || product.variantId || null,
            productName: product.product || 'Unknown',
            uom: alloc.uom || '',
            size: alloc.size || 1,
            quantity: alloc.quantity,
            packPrice: pharmacyPackPrice,              // per-pack pharmacy pays (2dp canonical)
            customerPackPrice: customerPackPrice,      // per-pack customer pays (2dp canonical)
            pharmacyUnitPrice: round2(packInfo?.pricing?.unitPurchasePriceIncVat || 0),
            customerUnitPrice: round2(packInfo?.pricing?.unitSellPriceIncVat || 0)
          }],
          
          // Pricing
          customerTotal: customerTotal,
          pharmacyTotal: pharmacyTotal
        };
        
        orderLines.push(packLine);
        console.log('Units line added:', packLine);
      });
      
      // Skip the normal push since we already added lines above
      // Update UI
      renderOrderSummary();
      
      // Reset calculator
      resetCalculator();
      
      // Show success feedback
      const totalPacks = algorithmResult.allocation.reduce((sum, a) => sum + a.quantity, 0);
      showSuccess(`Added ${algorithmResult.allocation.length} line${algorithmResult.allocation.length > 1 ? 's' : ''} (${totalPacks} pack${totalPacks > 1 ? 's' : ''}) to order`);
      
      return; // Exit early - don't run the normal add logic below
    }
    
    // Add to order (packs mode only reaches here)
    orderLines.push(line);
    console.log('Order lines now:', orderLines);
    
    // Update UI
    renderOrderSummary();
    
    // Reset calculator
    resetCalculator();
    
    // Show success feedback
    showSuccess(`Added ${line.productName} ${line.uom || ''} to order`);
  }

  // ============================================
  // RENDER ORDER SUMMARY
  // ============================================
  function renderOrderSummary() {
    const container = document.getElementById('nv-order-summary-list');
    
    // Total elements
    const pharmacyItemsEl = document.getElementById('nv-summary-pharmacy-items');
    const pharmacyDeliveryEl = document.getElementById('nv-summary-pharmacy-delivery');
    const pharmacyDeliveryRowEl = document.getElementById('nv-summary-pharmacy-delivery-row');
    const totalPharmacyEl = document.getElementById('nv-summary-total-pharmacy');
    
    const customerItemsEl = document.getElementById('nv-summary-customer-items');
    const customerDeliveryEl = document.getElementById('nv-summary-customer-delivery');
    const customerDeliveryRowEl = document.getElementById('nv-summary-customer-delivery-row');
    const totalCustomerEl = document.getElementById('nv-summary-total-customer');
    
    if (!container) return;
    
    if (orderLines.length === 0) {
      container.innerHTML = '<p class="v4p-text-muted">Add product lines using the calculator.</p>';
      
      // Reset all totals
      if (pharmacyItemsEl) pharmacyItemsEl.textContent = '£0.00';
      if (pharmacyDeliveryEl) pharmacyDeliveryEl.textContent = '£0.00';
      if (pharmacyDeliveryRowEl) pharmacyDeliveryRowEl.style.display = 'none';
      if (totalPharmacyEl) totalPharmacyEl.textContent = '£0.00';
      
      if (customerItemsEl) customerItemsEl.textContent = '£0.00';
      if (customerDeliveryEl) customerDeliveryEl.textContent = '£0.00';
      if (customerDeliveryRowEl) customerDeliveryRowEl.style.display = 'none';
      if (totalCustomerEl) totalCustomerEl.textContent = '£0.00';
      return;
    }
    
    let html = '';
    let itemsCustomerTotal = 0;
    let itemsPharmacyTotal = 0;
    
    // Calculate delivery
    const deliveryInfo = calculateDelivery();
    
    orderLines.forEach(line => {
      itemsCustomerTotal += line.customerTotal;
      itemsPharmacyTotal += line.pharmacyTotal;
      
      html += renderOrderLine(line);
    });
    
    // Add delivery line if applicable
    if (deliveryInfo.showDeliveryLine) {
      html += renderDeliveryLine(deliveryInfo);
    }
    
    container.innerHTML = html;
    
    // Update items totals
    if (pharmacyItemsEl) pharmacyItemsEl.textContent = formatCurrency(itemsPharmacyTotal);
    if (customerItemsEl) customerItemsEl.textContent = formatCurrency(itemsCustomerTotal);
    
    // Update delivery totals (show/hide rows based on whether there's delivery)
    if (deliveryInfo.showDeliveryLine) {
      // Show pharmacy delivery row (pharmacy always pays when there's delivery)
      if (pharmacyDeliveryRowEl) pharmacyDeliveryRowEl.style.display = '';
      if (pharmacyDeliveryEl) pharmacyDeliveryEl.textContent = formatCurrency(deliveryInfo.pharmacyDelivery);
      
      // Show/hide customer delivery row based on whether customer pays
      if (deliveryInfo.customerPaysDelivery) {
        if (customerDeliveryRowEl) customerDeliveryRowEl.style.display = '';
        if (customerDeliveryEl) customerDeliveryEl.textContent = formatCurrency(deliveryInfo.customerDelivery);
      } else {
        if (customerDeliveryRowEl) customerDeliveryRowEl.style.display = 'none';
      }
    } else {
      // No delivery - hide delivery rows
      if (pharmacyDeliveryRowEl) pharmacyDeliveryRowEl.style.display = 'none';
      if (customerDeliveryRowEl) customerDeliveryRowEl.style.display = 'none';
    }
    
    // Update grand totals (items + delivery)
    const grandTotalPharmacy = itemsPharmacyTotal + deliveryInfo.pharmacyDelivery;
    const grandTotalCustomer = itemsCustomerTotal + deliveryInfo.customerDelivery;
    
    if (totalPharmacyEl) totalPharmacyEl.textContent = formatCurrency(grandTotalPharmacy);
    if (totalCustomerEl) totalCustomerEl.textContent = formatCurrency(grandTotalCustomer);
    
    // Bind remove buttons
    container.querySelectorAll('.v4p-order-line__remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const lineId = parseInt(btn.dataset.lineId, 10);
        removeLine(lineId);
      });
    });
  }
  
  // ============================================
  // DELIVERY CALCULATION
  // ============================================
  function calculateDelivery() {
    if (orderLines.length === 0) {
      return {
        showDeliveryLine: false,
        deliveryCost: 0,
        customerDelivery: 0,
        pharmacyDelivery: 0,
        isColdChain: false,
        customerPaysDelivery: false,
        route: null
      };
    }
    
    // Get route from first line
    const route = (orderLines[0]?.route || 'VTP').toUpperCase();
    
    // DTP = Direct to Pharmacy, no delivery charges at all
    if (route === 'DTP') {
      return {
        showDeliveryLine: false,
        deliveryCost: 0,
        customerDelivery: 0,
        pharmacyDelivery: 0,
        isColdChain: orderLines.some(l => l.coldChain),
        customerPaysDelivery: false,
        isDirectToCustomer: false,
        route: route
      };
    }
    
    const STANDARD_DELIVERY_FEE = Number(window.V4P_CONFIG?.deliveryFees?.standard) || 5;
    const COLD_CHAIN_DELIVERY_FEE = Number(window.V4P_CONFIG?.deliveryFees?.coldChain) || 10;

    
    const hasColdChain = orderLines.some(l => l.coldChain);
    const hasStandard = orderLines.some(l => !l.coldChain);

    // Delivery cost formula
    const deliveryCost =
      (hasStandard ? STANDARD_DELIVERY_FEE : 0) +
      (hasColdChain ? COLD_CHAIN_DELIVERY_FEE : 0);

    
    // Delivery routes: VTCP, VTCU - V4P ships direct to customer
    // Collection routes: VTP, DSP - V4P ships to pharmacy, customer collects
    const deliveryRoutes = ['VTCP', 'VTCU'];
    const isDirectToCustomer = deliveryRoutes.includes(route);
    
    // Pharmacy ALWAYS pays delivery (except DTP which is handled above)
    const pharmacyDelivery = deliveryCost;
    
    // Customer only pays delivery on direct-to-customer routes (VTCP, VTCU)
    const customerPaysDelivery = isDirectToCustomer;
    const customerDelivery = customerPaysDelivery ? deliveryCost : 0;
    
    return {
      showDeliveryLine: true,
      deliveryCost: deliveryCost,
      customerDelivery: customerDelivery,
      pharmacyDelivery: pharmacyDelivery,

      // Delivery composition
      hasColdChain: hasColdChain,
      hasStandard: hasStandard,
      isMixedDelivery: hasColdChain && hasStandard,

      // Backwards-compatible flag
      isColdChain: hasColdChain,

      customerPaysDelivery: customerPaysDelivery,
      isDirectToCustomer: isDirectToCustomer,
      shipTo: isDirectToCustomer ? 'customer' : 'pharmacy',
      route: route
    };
  }
  
  // ============================================
  // RENDER DELIVERY LINE
  // ============================================
  function renderDeliveryLine(deliveryInfo) {
    const coldChainBadge = deliveryInfo.isColdChain 
      ? '<span class="v4p-tag v4p-tag--info v4p-tag--small">❄️ Cold Chain</span> ' 
      : '';
    
    // Label based on route type
    let deliveryLabel, deliveryNote;
    if (deliveryInfo.isDirectToCustomer) {
      // VTCP, VTCU - ships direct to customer
      deliveryLabel = 'Delivery to customer';
      deliveryNote = '';
    } else {
      // DTP, VTP, DSP - ships to pharmacy, customer collects
      deliveryLabel = 'Shipping to pharmacy';
      deliveryNote = '<span class="v4p-text-muted" style="font-size: 10px; margin-left: 4px;">(Customer collects)</span>';
    }
    
    return `
      <div class="v4p-order-line v4p-order-line--delivery" style="display: flex; align-items: center; gap: 8px; padding: 8px 10px; background: rgba(59, 130, 246, 0.05); border-radius: 6px; margin-bottom: 4px; border: 1px dashed rgba(59, 130, 246, 0.3); overflow: hidden;">
        
        <!-- Left: Delivery info -->
        <div style="flex: 1; min-width: 0; overflow: hidden;">
          <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 2px;">
            <span style="font-size: 10px;">${deliveryInfo.isDirectToCustomer ? '🚚' : '📦'}</span>
            ${coldChainBadge}
          </div>
          <div style="font-weight: 600; font-size: 12px;">
            ${deliveryLabel}${deliveryNote}
          </div>
        </div>
        
        <!-- Right: Prices -->
        <div style="flex-shrink: 0; text-align: right; font-size: 11px; line-height: 1.3; min-width: 70px;">
          <div style="color: rgba(var(--color-foreground), 0.5);">${formatCurrency(deliveryInfo.pharmacyDelivery)}</div>
          <div style="font-weight: 700; font-size: 13px;">${deliveryInfo.customerPaysDelivery ? formatCurrency(deliveryInfo.customerDelivery) : '–'}</div>
        </div>
        
        <!-- Placeholder for alignment with remove button -->
        <div style="flex-shrink: 0; width: 18px;"></div>
      </div>
    `;
  }

  function renderOrderLine(line) {
    console.log('Rendering order line:', line); // Debug
    
    // Build product display: Name + UOM × Qty
    let productDisplay = '';
    if (line.packSelection && line.packSelection.length > 0) {
      const p = line.packSelection[0]; // Now always single pack per line
      const name = (p.productName || line.productName);
      const uom = p.uom ? ` ${p.uom}` : '';
      productDisplay = `${escapeHtml(name)}${escapeHtml(uom)} × ${p.quantity}`;
    } else {
      productDisplay = escapeHtml(line.productName);
    }
    
    // Fulfilment icon (compact) - show first
    const fulfilmentIcon = line.fulfilmentMode === 'delivery' ? '🚚' : '🏪';
    
    // Product badges (Legal category from description, CD, Cold Chain, Stock)
    let productBadges = '';

    // --- Legal badge from description ---
    const desc = (line.description || '').toUpperCase();

    let legalBadge = null;
    if (desc.includes('POM-VPS')) legalBadge = 'POM-VPS';
    else if (desc.includes('POM-V')) legalBadge = 'POM-V';
    else if (desc.includes('NFA-VPS')) legalBadge = 'NFA-VPS';

    if (legalBadge) {
      productBadges += `<span class="v4p-tag v4p-tag--warning v4p-tag--small">${legalBadge}</span> `;
    }

    // --- Other badges ---
    if (line.controlledDrug) {
      productBadges += '<span class="v4p-tag v4p-tag--danger v4p-tag--small">CD</span> ';
    }
    if (line.coldChain) {
      productBadges += '<span class="v4p-tag v4p-tag--info v4p-tag--small">❄️</span> ';
    }

    
    // Repeat badge (compact)
    let repeatBadge = '';
    if (line.repeatType === 'repeat') {
      repeatBadge = `<span class="v4p-tag v4p-tag--small" style="background: rgba(59, 130, 246, 0.15); color: #3b82f6;">🔄</span>`;
    }
    
    // Waste indicator (for units mode - only on the line that has waste)
    let wasteText = '';
    if (line.orderType === 'units' && line.waste > 0) {
      wasteText = `<span style="color: #d97706; font-size: 10px; margin-left: 4px;">(+${line.waste} waste)</span>`;
    }

    return `
      <div class="v4p-order-line" data-line-id="${line.id}" style="display: flex; align-items: center; gap: 8px; padding: 8px 10px; background: rgba(var(--color-foreground), 0.03); border-radius: 6px; margin-bottom: 4px; border: 1px solid rgba(var(--color-foreground), 0.08); overflow: hidden;">
        
        <!-- Left: Product info (flex: 1 with min-width: 0 for text truncation) -->
        <div style="flex: 1; min-width: 0; overflow: hidden;">
          <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 2px;">
            <span style="font-size: 10px;">${fulfilmentIcon}</span>
            ${productBadges}
            ${repeatBadge}
          </div>
          <div style="font-weight: 600; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" title="${escapeHtml(productDisplay)}">
            ${productDisplay}${wasteText}
          </div>
        </div>
        
        <!-- Right: Prices (fixed width) -->
        <div style="flex-shrink: 0; text-align: right; font-size: 11px; line-height: 1.3; min-width: 70px;">
          <div style="color: rgba(var(--color-foreground), 0.5);">${formatCurrency(line.pharmacyTotal)}</div>
          <div style="font-weight: 700; font-size: 13px;">${formatCurrency(line.customerTotal)}</div>
        </div>
        
        <!-- Remove button -->
        <button type="button" class="v4p-order-line__remove" data-line-id="${line.id}" style="flex-shrink: 0; background: none; border: none; cursor: pointer; color: #dc3545; font-size: 16px; padding: 0 2px; line-height: 1;" title="Remove">×</button>
      </div>
    `;
  }

  // ============================================
  // REMOVE LINE
  // ============================================
  function removeLine(lineId) {
    orderLines = orderLines.filter(l => l.id !== lineId);
    renderOrderSummary();
  }

  // ============================================
  // RESET CALCULATOR
  // ============================================
  function resetCalculator() {
    // Reset inputs
    const packsInput = document.getElementById('nv-calc-packs-input');
    const unitsInput = document.getElementById('nv-calc-units-input');
    const searchInput = document.getElementById('nv-product-search');
    const loadingEl = document.getElementById('nv-product-loading');
    const contentEl = document.getElementById('nv-product-content');
    
    if (packsInput) packsInput.value = '0';
    if (unitsInput) unitsInput.value = '0';
    if (searchInput) searchInput.value = '';
    
    // Hide product content, show loading/empty
    if (loadingEl) {
      loadingEl.style.display = 'block';
      loadingEl.innerHTML = '<p class="v4p-text-muted">Search for a product above</p>';
    }
    if (contentEl) contentEl.style.display = 'none';
    
    // Reset totals display
    const customerTotalEl = document.getElementById('nv-calc-customer-total');
    const pharmacyTotalEl = document.getElementById('nv-calc-pharmacy-total');
    if (customerTotalEl) customerTotalEl.textContent = '£0.00';
    if (pharmacyTotalEl) pharmacyTotalEl.textContent = '£0.00';
    
    // Reset repeat fields using snippet's function
    if (window.V4PResetRepeatFields) {
      window.V4PResetRepeatFields();
    }
  }

  // ============================================
  // SUBMIT ORDER
  // ============================================
  function handleSubmitOrder() {
    if (orderLines.length === 0) {
      showError('Please add at least one product to the order');
      return;
    }
    
    // Validate screening checks
    const checks = [
      'check-rx-date',
      'check-pet-id', 
      'check-dose',
      'check-interactions'
    ];
    
    const allChecked = checks.every(id => {
      const el = document.getElementById(id);
      return el && el.checked;
    });
    
    if (!allChecked) {
      showError('Please complete all screening checks');
      return;
    }
    
    // Validate processed by confirmation
    const processedConfirm = document.getElementById('nv-processed-confirm');
    if (!processedConfirm || !processedConfirm.checked) {
      showError('Please confirm you have completed the pre-screen checks');
      return;
    }
    
    // Get processed by data
    const processedJson = document.getElementById('nv-processed-staff-json');
    let processedBy = null;
    try {
      processedBy = JSON.parse(processedJson?.value || 'null');
    } catch (e) {}
    
    if (!processedBy || !processedBy.firstName || !processedBy.lastName) {
      showError('Please enter staff details for who processed this order');
      return;
    }
    
    // Get customer/patient info from left column
    const customerData = getCustomerData();
    const patientData = getPatientData();
    const prescriptionData = getPrescriptionData();
    const responsibleStaff = getResponsibleStaffData();
    
    // Build full order payload
    const orderPayload = {
      prescription: prescriptionData,
      customer: customerData,
      patient: patientData,
      responsibleStaff: responsibleStaff,
      lines: orderLines,
      processedBy: processedBy,
      screeningCompleted: true,
      totals: {
        customerTotal: orderLines.reduce((sum, l) => sum + (l.customerTotal || 0), 0),
        pharmacyTotal: orderLines.reduce((sum, l) => sum + (l.pharmacyTotal || 0), 0)
      },
      createdAt: new Date().toISOString()
    };
    
    console.log('Order Payload:', orderPayload);
    
    // TODO: Send to worker API
    // For now, show success
    showSuccess('Order submitted successfully!');
    
    // Dispatch event for other components
    window.dispatchEvent(new CustomEvent('v4p:order-submitted', {
      detail: orderPayload
    }));
  }

  // ============================================
  // GET LEFT COLUMN DATA
  // ============================================
  function getCustomerData() {
    // Read from actual form fields in left column
    const firstName = document.getElementById('nv-customer-firstname')?.value?.trim() || '';
    const lastName = document.getElementById('nv-customer-lastname')?.value?.trim() || '';
    const phone = document.getElementById('nv-customer-phone')?.value?.trim() || '';
    const email = document.getElementById('nv-customer-email')?.value?.trim() || '';
    
    // Address fields
    const address = {
      line1: document.getElementById('nv-customer-address-line1')?.value?.trim() || '',
      line2: document.getElementById('nv-customer-address-line2')?.value?.trim() || '',
      city: document.getElementById('nv-customer-city')?.value?.trim() || '',
      postcode: document.getElementById('nv-customer-postcode')?.value?.trim() || ''
    };
    
    return {
      firstName: firstName,
      lastName: lastName,
      fullName: (firstName + ' ' + lastName).trim(),
      phone: phone,
      email: email,
      address: address
    };
  }

  function getPatientData() {
    // Read from actual form fields (pet health questionnaire)
    const petName = document.getElementById('nv-pet-name')?.value?.trim() || '';
    const species = document.getElementById('nv-pet-species')?.value || '';
    const breed = document.getElementById('nv-pet-breed')?.value?.trim() || '';
    const age = document.getElementById('nv-pet-age')?.value?.trim() || '';
    const dob = document.getElementById('nv-pet-dob')?.value || null;
    const weight = document.getElementById('nv-pet-weight')?.value || '';
    const gender = document.getElementById('nv-pet-gender')?.value || '';
    const neuteringStatus = document.getElementById('nv-pet-neutered')?.value || '';
    
    // Health questions (radio buttons)
    const hasAllergies = document.querySelector('input[name="pet-allergies"]:checked')?.value === 'yes';
    const allergiesDetails = document.getElementById('nv-pet-allergies-detail')?.value?.trim() || null;
    const onOtherMeds = document.querySelector('input[name="pet-other-meds"]:checked')?.value === 'yes';
    const otherMedsDetails = document.getElementById('nv-pet-other-meds-detail')?.value?.trim() || null;
    const registeredVets4u = document.querySelector('input[name="pet-vets4u"]:checked')?.value === 'yes';
    const readProductInfo = document.querySelector('input[name="pet-product-info"]:checked')?.value === 'yes';
    const microchip = document.getElementById('nv-pet-microchip')?.value?.trim() || null;
    
    // Vet practice
    const vetPracticeName = document.getElementById('nv-vet-practice-name')?.value?.trim() || '';
    const vetPracticePostcode = document.getElementById('nv-vet-practice-postcode')?.value?.trim() || '';
    
    return {
      name: petName,
      species: species,
      breed: breed,
      age: age,
      dob: dob,
      weightKg: parseFloat(weight) || null,
      gender: gender,
      neuteringStatus: neuteringStatus,
      hasAllergies: hasAllergies,
      allergiesDetails: allergiesDetails,
      onOtherMeds: onOtherMeds,
      otherMedsDetails: otherMedsDetails,
      registeredVets4u: registeredVets4u,
      readProductInfo: readProductInfo,
      microchip: microchip,
      vetPractice: {
        name: vetPracticeName,
        postcode: vetPracticePostcode
      }
    };
  }

  function getPrescriptionData() {
    // Get prescription data from hidden field or uploader
    let imageBase64 = null;
    let filename = null;
    
    // Try hidden prescription-data field first
    try {
      const rxDataEl = document.getElementById('nv-prescription-data');
      if (rxDataEl && rxDataEl.value) {
        const rxData = JSON.parse(rxDataEl.value);
        imageBase64 = rxData.imageData || rxData.imageBase64 || rxData.croppedImage || null;
        filename = rxData.filename || null;
      }
    } catch (e) {
      console.error('Failed to parse prescription-data:', e);
    }
    
    // Fallback to uploader module
    if (!imageBase64 && window.prescriptionUploader) {
      if (typeof window.prescriptionUploader.getData === 'function') {
        const uploaderData = window.prescriptionUploader.getData();
        imageBase64 = uploaderData?.imageData || uploaderData?.imageBase64 || null;
        filename = uploaderData?.filename || filename;
      }
    }
    
    // Get prescription details from form
    return {
      imageBase64: imageBase64,
      filename: filename || document.getElementById('nv-prescription-filename')?.value || null,
      dateIssued: document.getElementById('nv-rx-date-issued')?.value || null,
      expiryDate: document.getElementById('nv-rx-expiry-date')?.value || null,
      prescriberName: document.getElementById('nv-rx-prescriber-name')?.value?.trim() || null,
      prescriberRcvs: document.getElementById('nv-rx-prescriber-rcvs')?.value?.trim() || null
    };
  }

  function getResponsibleStaffData() {
    // Get responsible staff (pharmacist/dispenser who verified Rx)
    let staffData = null;
    try {
      const staffEl = document.getElementById('nv-rx-responsible-staff-json');
      if (staffEl && staffEl.value) {
        staffData = JSON.parse(staffEl.value);
      }
    } catch (e) {
      console.error('Failed to parse responsible staff data:', e);
    }
    
    return {
      selectionType: staffData?.source || 'manual',
      firstName: staffData?.firstName || document.getElementById('nv-staff-firstname')?.value?.trim() || '',
      lastName: staffData?.lastName || document.getElementById('nv-staff-lastname')?.value?.trim() || '',
      role: staffData?.role || document.getElementById('nv-staff-role')?.value || '',
      registrationNumber: staffData?.registrationNumber || document.getElementById('nv-staff-reg-number')?.value?.trim() || '',
      verificationConfirmed: document.getElementById('nv-staff-confirm-rx')?.checked || false
    };
  }

  // ============================================
  // UTILITIES
  // ============================================

  function round2(n) {
  const x = Number(n);
  return Number.isFinite(x) ? Math.round(x * 100) / 100 : 0;
}


  function formatCurrency(value) {
    const num = parseFloat(value) || 0;
    return '£' + num.toFixed(2);
  }
  
  function parseCurrencyDisplay(text) {
    // Parse a displayed currency value like "£82.65" or "£413.25" to a number
    if (!text) return 0;
    const cleaned = String(text).replace(/[^0-9.-]/g, '');
    const num = parseFloat(cleaned);
    return Number.isFinite(num) ? num : 0;
  }

  function escapeHtml(str) {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function showError(message) {
    // Simple alert for now - could be replaced with toast
    alert('⚠️ ' + message);
  }

  function showSuccess(message) {
    // Could be replaced with toast notification
    console.log('✅ ' + message);
    
    // Brief visual feedback on add button
    const addBtn = document.getElementById('nv-btn-add-line');
    if (addBtn) {
      const originalText = addBtn.textContent;
      addBtn.textContent = '✓ Added!';
      addBtn.disabled = true;
      setTimeout(() => {
        addBtn.textContent = originalText;
        addBtn.disabled = false;
      }, 1000);
    }
  }

  // ============================================
  // PUBLIC API
  // ============================================
  window.V4PNonVetOrderManager = {
    getOrderLines: () => orderLines,
    getDeliveryInfo: calculateDelivery,
    addLine: handleAddLine,
    removeLine: removeLine,
    clearOrder: () => {
      orderLines = [];
      renderOrderSummary();
    },
    getOrderPayload: () => {
      const deliveryInfo = calculateDelivery();
      const productCustomerTotal = orderLines.reduce((sum, l) => sum + (Number(l.customerTotal) || 0), 0);
      const productPharmacyTotal = orderLines.reduce((sum, l) => sum + (Number(l.pharmacyTotal) || 0), 0);

      return {
        lines: orderLines,

        order: {
          route: deliveryInfo.route,
          fulfilmentMode: orderLines[0]?.fulfilmentMode || null
        },

        delivery: {
          route: deliveryInfo.route,
          isDirectToCustomer: deliveryInfo.isDirectToCustomer,
          shipTo: deliveryInfo.shipTo,

          // Cold/standard split
          hasColdChain: deliveryInfo.hasColdChain,
          hasStandard: deliveryInfo.hasStandard,
          isMixedDelivery: deliveryInfo.isMixedDelivery,

          // Backwards-compatible
          isColdChain: deliveryInfo.isColdChain,

          deliveryCost: deliveryInfo.deliveryCost,
          customerPaysDelivery: deliveryInfo.customerPaysDelivery,
          customerDelivery: deliveryInfo.customerDelivery,
          pharmacyDelivery: deliveryInfo.pharmacyDelivery
        },

        totals: {
          productCustomerTotal: productCustomerTotal,
          productPharmacyTotal: productPharmacyTotal,
          deliveryCustomer: deliveryInfo.customerDelivery,
          deliveryPharmacy: deliveryInfo.pharmacyDelivery,
          customerTotal: productCustomerTotal + (Number(deliveryInfo.customerDelivery) || 0),
          pharmacyTotal: productPharmacyTotal + (Number(deliveryInfo.pharmacyDelivery) || 0)
        }
      };
    }
  };

  // ============================================
  // INIT ON DOM READY
  // ============================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();